import React from 'react'

import TableHeader from './header'

import RevenueRow from './revenue-row'
import TotalRow from './total-row'

import './revenue-list.css'
import './table-column-sizes.css'

export default ({ revenues, reportType, offset, size, revenueTotals, loading, onLoadMore, sort, sortOrder, onSortChange }) => {
    return (
        <div class="table-responsive">
            <table className="revenue-list revenue-list--table">
                <TableHeader reportType={reportType} sort={sort} sortOrder={sortOrder} onSortChange={onSortChange} />
                <tbody>
                    {!revenues || revenues.length === 0 ? (
                        <tr className="revenue-list revenue-list--header">
                            <td className="revenue-list revenue-list--property" colSpan="8">
                                No data for the selected interval
                            </td>
                        </tr>
                    ) : (
                        revenues.map((revenue, index) => (
                            <RevenueRow
                                key={index + '_' + revenue.ar_list_id + '_' + revenue.product + '_' + revenue.market}
                                reportType={reportType}
                                data={revenue}
                            />
                        ))
                    )}

                    {loading && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                    Loading...
                                </button>
                            </td>
                        </tr>
                    )}

                    {!loading && revenues.length >= offset + size && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" onClick={onLoadMore}>
                                    Load more
                                </button>
                            </td>
                        </tr>
                    )}
                    {revenueTotals && <TotalRow reportType={reportType} revenueTotals={revenueTotals} />}
                </tbody>
            </table>
        </div>
    )
}
